import { NetGainByScheduledPayementDateOutput, TransactionInvalidReason } from '@allocab/allocab-invoice-service-types';

import { t } from '../../services/translation/translation';
import { assertNever } from '../../utils/common';
import { formatDate } from '../../utils/date';

export const getRejectionReason = (reason: TransactionInvalidReason) => {
  switch (reason) {
    case 'BANK_REJECTION':
      return 'Rejet de la banque';
    case 'INCOHERENCE_BETWEEN_IBAN_AND_BIC_COUNTRIES':
      return 'Incohérence entre IBAN et pays du BIC';
    case 'INVALID_BIC':
      return 'BIC non valide';
    case 'INVALID_IBAN':
      return 'IBAN non valide';
    case 'INVALID_IBAN_COUNTRY':
      return `Pays de l'IBAN invalide`;
    case 'NEGATIVE':
      return 'Facture Négative';
    case 'NO_RIB':
      return 'Pas de RIB';
    case 'RIB_OWNER_INFORMATION_MISSING':
      return 'Pas de détenteur de RIB';
    case 'INVOICES_ALREADY_PAID':
      return 'Factures déjà payées';
    default:
      assertNever(reason, '[getRejectionReason] Reason unknown');
      return '';
  }
};

export const getPaymentLabel = (data: NetGainByScheduledPayementDateOutput) => {
  const paymentInfo = data.paymentInformations;
  if (paymentInfo?.from && paymentInfo?.to) {
    return t('transaction.date.between');
  }
  if (paymentInfo?.from) {
    return t('transaction.date.from');
  }
  return t('transaction.date.on');
};

export const getPaymentText = (data: NetGainByScheduledPayementDateOutput) => {
  const paymentInfo = data.paymentInformations;

  if (paymentInfo?.from && paymentInfo?.to) {
    return `${formatDate(paymentInfo.from, t('date.date-longer'))} et ${formatDate(
      paymentInfo.to,
      t('date.date-longer'),
    )}`;
  }
  if (paymentInfo?.from && !paymentInfo?.to) {
    return formatDate(paymentInfo.from, t('date.date-longer'));
  }
  return formatDate(data.scheduledPaymentDate, t('date.date-longer'));
};
